<script lang="ts" setup>
    import RothcoCta from "./RothcoCta.vue";
    import { computed } from "vue";
    import type { Cta } from "@/helpers/builder-init/index";
    import { getCtaLink } from "@/helpers/interfaces/Cta";
    import { useRothcoBreakpoints } from "@/helpers/composables/useBreakpoints";
    import * as themeColors from "@assets/styles/colors.module.scss";
    import useImageOptimization from "@/helpers/composables/useImageOptimization";
    interface LauncherItem {
        headline: string;
        image: string;
        image_alt: string;
        cta: Cta;
    }

    interface LauncherRow {
        launcherItems: LauncherItem[];
    }
    let props = defineProps({
        headline: {
            type: String,
            default: ""
        },
        launcherRows: {
            type: Array as PropType<Array<LauncherRow[]>>,
            default() {
                return [];
            }
        },
        use_gradient: {
            type: Boolean,
            default: false
        },
        gradient_color: {
            type: String,
            default: 'rothcoBlack'
        },
        togglePadding: {
            type: Boolean,
            default: false
        },
    });

    let launcherClasses = computed(() => {
        return {'palette-items-container': true};
        // if(props.headline.length > 0){
        //     return {'palette-items-container': true};
        // }
        // let totalItems = props.launcherRows.reduce((acc, row) => {
        //     return acc + row.launcherItems.length;
        // }, 0);
        // return {
        //     "palette-three-items": totalItems <= 3,
        //     "palette-four-items": (totalItems == 4),
        //     "palette-five-items": totalItems > 4,
        // };
    });


    let getRowClass = (row) => {
        let itemsLength = row.launcherItems.length;
        switch (itemsLength) {
            case 1:
            case 2:
            case 3:
                return "palette-three-items";
            case 4:
                return "palette-four-items";
            default:
                return "palette-five-items";
        }
    };

    function hasButton(item) {
        return item.headline?.length > 0;
    }

    const cssVars = computed(() => {
        if(props.use_gradient){
            let r,g,b;
            let gradientColor = themeColors[props.gradient_color] ?? themeColors['rothcoBlack'];
            if(gradientColor){
                r = parseInt(gradientColor.substring(1, 3), 16);
                g = parseInt(gradientColor.substring(3, 5), 16);
                b = parseInt(gradientColor.substring(5, 7), 16);
            }
            return {
                "--category-launcher-gradient": gradientColor ? `${r}, ${g}, ${b}` : undefined
            };
        }else{
            return [];
        }
    });

    let breakpoints = useRothcoBreakpoints();
    let breakpointIsMobile = computed(()=>{
        return breakpoints.smaller('laptop').value;
    });

    let { optimize } = useImageOptimization();

</script>
<template>
    <section :class="{...launcherClasses, 'alternative-padding': props.togglePadding}" :style="cssVars">
        <span class="headline-l palette-title" v-if="headline.length > 0">{{
            headline
        }}</span>

        <div
            :class="{
                'paletted-row': headline.length == 0,
                'palette-three-items': row.launcherItems.length == 1 || row.launcherItems.length == 2 || row.launcherItems.length == 3,
                'palette-four-items': row.launcherItems.length == 4,
                'palette-five-items': row.launcherItems.length > 4
            }"
            v-for="(row, rowIndex) in launcherRows"
            :key="rowIndex"
        >
            <component
                :is="item.cta && !breakpointIsMobile ? RothcoCta : 'div'"
                v-bind="item.cta ? getCtaLink(item.cta) : {}"
                ctaType="link"
                html-slotted
                v-for="(item, itemIndex) in row.launcherItems"
                :key="itemIndex"
                :class="{
                    'pti-item': true,
                    third: row.launcherItems.length == 3,
                    half: row.launcherItems.length == 2
                }"
                :aria-label="item.headline"
                :disabled="!item.cta"
            >
                <img
                    loading="lazy"
                    :src="optimize(item.image)"
                    :alt="item.image_alt"
                    class="pti-image"
                    id="category_image"
                />
                <RothcoCta v-if="!breakpointIsMobile && item.headline" type="button" :class="(item?.cta?.style ?? 'secondary dark')">
                    {{ item.headline }}
                </RothcoCta>
                <RothcoCta v-else-if="item.headline" :href="item.cta ? getCtaLink(item.cta).href : '#'" type="button" :class="(item?.cta?.style ?? 'secondary dark')">
                    {{ item.headline }}
                </RothcoCta>
            </component>
        </div>
    </section>
</template>
